import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import APIClient from '../../client';
import HeaderView from '../../widgets/header';
import FooterView from '../../widgets/footer';
import './style.css';

class View extends Component {
  constructor(params) {
    super(params);
    this.state = {

      item:             null,
      locality:         params.locality,
      user:             params.user,
      species:          (params.match.params || {}).breedkey || null,
      section:          'loading'

    };
    this.handleUserChange = params.handleUserChange;
  }
  componentDidMount = async () => {

    // set the call
    let sresponse = await APIClient.call({

      path:   '/species/' + this.state.species,
      query:  {}

    });

    this.setState({

      item:         sresponse.data || null

    });

    // set the call
    let bresponse = await APIClient.call({

      path:   '/breeds',
      query:  {
        species: this.state.species
      }

    });

    this.setState({

      item:         bresponse.data || null,
      items:        bresponse.data || []

    });

  }
  render() {
    if(this.state.section === 'loading') {
      return (<div className="initialoading">
        <div className="dots">
          <div className="dot dot1"></div>
          <div className="dot dot2"></div>
          <div className="dot dot3"></div>
          <div className="dot dot4"></div>
          <div className="dot5"></div>
        </div>
        <h2 className="initialoading-heading">One sec just loading...</h2>
      </div>);
    }
    return (
      <div>
        <HeaderView {...this.props} locality={this.state.locality}  user={this.state.user} state={this.state} />
        <div className="wrapper">
          <div className="breeds">
            <div className="container">
              <div className="breeds-inner">

                {this.state.item.name}
                <br />
                {this.state.item.summary}
                <br />
                <br />

                {
                  this.state.items.map((item) => {
                    return <div key={item.key}>
                      <Link to={"/species/" + item.slug}>
                        <img alt={"Image example of " + item.name} style={{
                          width: 64
                        }} src={null} />
                        <p>{item.name}</p>
                      </Link>
                    </div>;
                  })
                }

                <div className="clearfix"></div>

              </div>
            </div>
          </div>
        </div>
        <FooterView locality={this.state.locality} state={this.state} />
      </div>
    );
  }
}

export default View;